var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestPriceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52600",
    "data-name": "Group 52600",
    transform: "translate(-730 -1631.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1639",
    "data-name": "Rectangle 1639",
    transform: "translate(730 1631.612)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_14_",
    "data-name": "svgexport-7 (14)",
    transform: "translate(740.807 1641.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91011",
    "data-name": "Path 91011",
    d: "M27.4,15.49,11.51,43a5,5,0,0,0,1.83,6.83L28.5,58.59A6.94,6.94,0,0,1,28,56V24.23a11,11,0,0,1,3.08-7.64L37.46,10,32.7,11.34a9,9,0,0,0-5.3,4.15Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91012",
    "data-name": "Path 91012",
    d: "M4.85,33.58a5,5,0,0,0,0,7.07l4,4A7,7,0,0,1,9.78,42C12.11,38,22.41,20.13,28,10.53,27.33,11.05,28.55,9.9,4.85,33.58Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91013",
    "data-name": "Path 91013",
    d: "M43.71,39H44V35h-.29a2,2,0,1,0,0,4Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91014",
    "data-name": "Path 91014",
    d: "M51,2.87a13.63,13.63,0,0,1-2.94,6.4,5,5,0,0,0-7.17,0L32.52,18A9,9,0,0,0,30,24.23V56a5,5,0,0,0,5,5H54a5,5,0,0,0,5-5V24.23A9,9,0,0,0,56.48,18l-5.61-5.82a13,13,0,0,1-4.49,3.17,2.011,2.011,0,1,1-.41-2.01,10.36,10.36,0,0,0,1.75-1h0a14.06,14.06,0,0,0,1.76-1.57h0A15.22,15.22,0,0,0,53,3.12ZM43.71,33H44V30.57h2V33h.29a4,4,0,0,1,4,4h-2a2,2,0,0,0-2-2H46v4h.29a4,4,0,1,1,0,8H46v2.43H44V47h-.29a4,4,0,0,1-4-4h2a2,2,0,0,0,2,2H44V41h-.29a4,4,0,1,1,0-8Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91015",
    "data-name": "Path 91015",
    d: "M48.29,43a2,2,0,0,0-2-2H46v4h.29A2,2,0,0,0,48.29,43Z",
    fill: "#93a750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestPriceIcon);
export default __webpack_public_path__ + "static/media/TestPriceIcon.00c4669d8c93c4b6e4d57f0610288c3d.svg";
export { ForwardRef as ReactComponent };